import { Image } from '~/components/Image';
import type { Publication } from '~/interfaces/publication';

import Text from '../Text';

interface Props {
  theme: 'subscribe' | 'content' | 'navs' | 'default' | 'primary';
  publication: Publication;
}

const PublicationHeading = ({ theme = 'subscribe', publication }: Props) => {
  const logoShadow = publication?.web_theme?.logo_shadow;
  let shadowClass = 'shadow-md';

  if (logoShadow === 'md') {
    shadowClass = 'shadow-md';
  } else if (logoShadow === 'none') {
    shadowClass = 'shadow-none';
  } else if (logoShadow === 'sm') {
    shadowClass = 'shadow-sm';
  } else if (logoShadow === 'lg') {
    shadowClass = 'shadow-lg';
  }

  return (
    <div className="flex w-full flex-col items-center">
      <div className={`mb-4 h-24 w-24 overflow-hidden rounded sm:mb-8 ${shadowClass}`}>
        {publication.logo.thumb.url && (
          <Image src={publication.logo.thumb.url} alt={publication.name} maxWidth={200} aspectRatio="square" />
        )}
      </div>
      <div className="mb-6 flex flex-col items-center space-y-2.5 sm:space-y-3">
        {publication.name && (
          <Text
            as="h1"
            type="title"
            size="5xl"
            theme={theme}
            className="w-full break-words text-center leading-tight tracking-normal"
          >
            {publication.name}
          </Text>
        )}
        {publication.description && (
          <Text as="p" type="body" theme={theme} className="text-md text-center tracking-wide opacity-75 sm:text-lg">
            {publication.description}
          </Text>
        )}
      </div>
    </div>
  );
};

export default PublicationHeading;
